import type { AxiosInstance, AxiosRequestConfig } from 'axios';
import type { Address } from 'viem';
import fallback from '~/api/fallback';

export default (http: AxiosInstance) => ({

    async getNft(collection: string, identifier: string, owner?: Address) {
        const res = await http.get<AppWTFNftResponse>(`/nft/${collection}/${identifier}`, { params: owner ? { owner } : {} });
        return res.data;
    },

    async getNftOwners(collection: string, identifier: string, query?: AppWTFNftOwnersQuery) {
        const fallbackConfig = fallback<AppWTFNftOwnersListResponse>({
            text: 'Loading NFT owners',
            description: 'An error occurred while loading NFT owners',
            visible: 'error',
            exclude: [
                404,
                403
            ],
            fallback: {
                data: [],
                pagination: {
                    page: 0,
                    size: 0,
                    total: 0
                },
                status: {
                    code: 404,
                    message: 'Response fallbackApi get NFT owners',
                    msgId: '1'
                }
            }
        });

        const config: AxiosRequestConfig = {
            params: {
                ...query
                    ? { ...query }
                    : {}
            },
            ...fallbackConfig
        };

        const res = await http.get<AppWTFNftOwnersListResponse>(
            `/nft/${collection}/${identifier}/owners`,
            config
        );

        return res.data;
    },

    async getNftByWallet(wallet: User['address'], query?: AppWTFNftWalletListQuery) {
        const fallbackConfig = fallback<AppWTFNftListResponse>({
            text: 'Loading Nft collections',
            description: 'An error occurred while loading Nft collections',
            visible: 'error',
            exclude: [
                404,
                403
            ],
            fallback: {
                data: [],
                next: '',
                pagination: {
                    page: 0,
                    size: 0,
                    total: 0
                },
                status: {
                    code: 404,
                    message: 'Response fallbackApi get Nft By Wallet',
                    msgId: '1'
                }
            }
        });
        const config: AxiosRequestConfig = {
            params: {
                ...query
                    ? { ...query }
                    : {}
            },
            ...fallbackConfig
        };

        const res = await http.get<AppWTFNftListResponse>(
            `/nfts/${wallet}`,
            config
        );
        return res.data;
    },

    async getNftTransferHistory(requestData: AppWTFTransferHistoryRequest) {
        const fallbackConfig = fallback<AppWTFTransferHistoryResponse>({
            text: 'Loading transfer history',
            description: 'An error occurred while loading Nft AppWTFTransferHistoryResponse',
            visible: 'error',
            exclude: [
                404,
                403
            ],
            fallback: {
                data: [],
                nextTS: '',
                status: {
                    code: 404,
                    message: 'Response fallbackApi get transfer history',
                    msgId: '1'
                }
            }
        });

        const res = await http.get<AppWTFTransferHistoryResponse>(
            `/transfers/history/${requestData.network}/${requestData.address}/${requestData.identifier}`,
            {
                params: {
                    createBefore: requestData.createdBefore,
                    size: requestData.size
                },
                ...fallbackConfig
            }
        );

        return res.data;
    },

    async updateToRefresh(uuid: string) {
        const response = await http.post<ApiEmptyResponse>(
            `/nft/${uuid}/refresh`,
            {},
            {
                params: {
                    uuid
                }
            }
        );
        return response.data;
    }
} as const);
